"use client"

// src/components/scale-fade.ts
var ScaleFade = {
  baseStyle: {
    w: "100%"
  },
  defaultProps: {
    reverse: true,
    scale: 0.95
  }
};

export {
  ScaleFade
};
//# sourceMappingURL=chunk-7VKQ3CN7.mjs.map